import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { useBranches } from "@/hooks/useBranches";

export type SelectedBranchId = string | "all";

const BranchContext = createContext<{
  selectedBranchId: SelectedBranchId;
  setSelectedBranchId: (id: SelectedBranchId) => void;
  branches: ReturnType<typeof useBranches>["branches"];
  isLoading: boolean;
}>({
  selectedBranchId: "all",
  setSelectedBranchId: () => {},
  branches: [],
  isLoading: false,
});

export function useBranchContext() {
  return useContext(BranchContext);
}

/** Provides global branch selection. Use selectedBranchId to filter data; "all" = consolidated view. */
export function BranchProvider({ children }: { children: ReactNode }) {
  const { branches, loading } = useBranches();
  const [selectedBranchId, setSelectedBranchIdState] = useState<SelectedBranchId>("all");

  const setSelectedBranchId = useCallback((id: SelectedBranchId) => {
    setSelectedBranchIdState(id);
  }, []);

  return (
    <BranchContext.Provider
      value={{
        selectedBranchId,
        setSelectedBranchId,
        branches,
        isLoading: loading,
      }}
    >
      {children}
    </BranchContext.Provider>
  );
}
